export const PART_CONSTRAINTS = {
    num: { maxLength: 70, label: 'Part number' },
    name: { maxLength: 252, label: 'Name' },
    description: { maxLength: 5_000, label: 'Description' },
    revision: { maxLength: 15, label: 'Revision' },
    vendorPartNumber: { maxLength: 70, label: 'Vendor part number' },
    stdCost: { label: 'Standard cost' },
    leadTime: { label: 'Lead time' },
    reorderPoint: { label: 'Reorder point' },
    orderUpToLevel: { label: 'Order-up-to level' },
    vendorLastCost: { label: 'Vendor cost' },
    vendorLeadTime: { label: 'Vendor lead time' },
    vendorQtyMin: { label: 'Minimum order quantity' },
    upc: { maxLength: 31, label: 'UPC' },
    url: { maxLength: 256, label: 'URL' },
    alertNote: { maxLength: 256, label: 'Alert note' },
    weight: { label: 'Weight' },
    len: { label: 'Length' },
    width: { label: 'Width' },
    height: { label: 'Height' },
    receivingTol: { label: 'Receiving tolerance' },
    cycleCountTol: {
        label: 'Cycle count tolerance',
        max: 100,
        maxMessage: 'Cycle count tolerance is a percentage, so 100 is the most.',
    },
};
export const MAX_VENDOR_PARTS_PER_CREATE = 50;
export const MAX_VENDOR_PARTS_PER_CREATE_MESSAGE = `A maximum of ${MAX_VENDOR_PARTS_PER_CREATE} vendors can be linked to a part.`;
export const MAX_STOCK_SETUP_LOCATIONS = 50;
export const MAX_PART_BRAND_IDS = 50;
//# sourceMappingURL=constraints.js.map